// Story 16.5 — cómo se muestran los roles de una organización.

import type { OrganizationRole } from './permissions';

export const ORGANIZATION_ROLES: readonly OrganizationRole[] = ['owner', 'editor', 'viewer'];

export const ROLE_LABELS: Record<OrganizationRole, string> = {
  owner: 'Owner',
  editor: 'Editor',
  viewer: 'Viewer',
};

export const ROLE_DESCRIPTIONS: Record<OrganizationRole, string> = {
  owner: 'Todo, incluidos los miembros y las credenciales',
  editor: 'Crear, editar, deployar y hacer rollback de bots',
  viewer: 'Ver bots, conversaciones y analytics',
};
